import { ApolloError } from '@apollo/client'
import { GraphQLFormattedError } from 'graphql'

export enum FilterErrorType {
    LOCATION = 'location',
    PAGE = 'page',
}

export function containsFilterError(
    graphQLErrors: ReadonlyArray<GraphQLFormattedError>,
    errorType: FilterErrorType
): boolean {
    for (const err of graphQLErrors) {
        switch (err?.extensions?.errorDetail) {
            case 'INVALID_ARGUMENT':
                if (errorType === (err?.extensions.filters as { filter: string }[])[0].filter) {
                    return true
                }
                if (
                    errorType === FilterErrorType.LOCATION &&
                    ('postcode' === (err?.extensions.filters as { filter: string }[])[0].filter ||
                        'distance' === (err.extensions.filters as { filter: string }[])[0].filter)
                ) {
                    return true
                }
        }
    }

    return false
}

export const isFilterError = (networkError: ApolloError | undefined, errorType: FilterErrorType): boolean => {
    const graphQLErrors = networkError && networkError.graphQLErrors ? networkError.graphQLErrors : []
    return containsFilterError(graphQLErrors, errorType)
}

export const isPostcodeFilterError = (networkError: ApolloError | undefined) => {
    return networkError?.graphQLErrors.find((error) =>
        (error?.extensions?.filters as { filter: string; reason: string }[])?.find(
            (filter) => filter.filter === 'postcode'
        )
    )
}
